import React, { useState } from 'react';
import { Content, Row, Col, Title, Text } from 'components';
import { SideMenu } from '../components';
import Product from 'assets/product_01.png';
import OrderListTable from '../components/OrderListTable/OrderListTable';
import { stringToMoneyFormat } from 'utils';
import { Button } from 'antd';
import equal from 'assets/equal.svg';
import remove from 'assets/remove.svg';
import more from 'assets/more.svg';

const MypageSubscribeDetailsPresenter = () => {
  const styles = {
    title: {
      fontSize: 24,
      fontWeight: 700,
      color: 'var(--black-color)',
    },
    titleLayout: {
      display: 'flex',
      gap: 8,
      alignItems: 'center',
      paddingBottom: 32,
      borderBottom: '2px solid var(--black-color)',
    },
    button: {
      width: 143,
      height: 48,
      fontSize: 16,
      fontWeight: 700,
    },
    listButton: {
      fontSize: 16,
      fontWeight: 700,
      backgroundColor: 'var(--black-color)',
      color: 'var(--white-color)',
      width: 240,
      height: 64,
      borderRadius: 4,
    },
    container: {
      display: 'flex',
      flexDirection: 'column',
    },
    section: {
      height: 92,
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      padding: '32px 40px',
      fontWeight: 700,
      borderBottom: '1px solid #ddd',
    },
    columnSection: {
      display: 'flex',
      flexDirection: 'column',
      gap: 16,
      padding: '32px 40px',
    },
    row: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
    },
    text: {
      fontSize: 14,
    },
    lighttext: {
      fontSize: 12,
      color: 'var(--dark-gray-color)',
    },
    paytitle: {
      fontSize: 16,
      fontWeight: 700,
    },
  };

  /* 주문내역 */
  const recentOrderList = [
    {
      created_at: new Date(),
      product_name: '시그니처블랜드 617th 에비뉴 200g',
      place_name: 'JMCOFFEE',
      product_data: '분쇄안함 / 200g / 500개',
      src: Product,
      orderNum: '202411271528245138332426',
      num: 1,
      price: 6000000,
      deliver: '택배배송',
      status: '상품준비중',
      expectedCycle: 10, // 회차 정보
    },
    {
      created_at: new Date(),
      product_name: '시그니처블랜드 617th 에비뉴 200g',
      place_name: 'JMCOFFEE',
      product_data: '분쇄안함 / 200g / 500개',
      src: Product,
      orderNum: '202411271528245138332426',
      num: 1,
      price: 6000000,
      deliver: '택배배송',
      status: '상품준비중',
      expectedCycle: 10, // 회차 정보
    },
  ];

  return (
    <Content maxWidth={1820} padding={'120px 0px 200px'}>
      <Row gutter={25}>
        <Col x={2}></Col>
        <Col x={4}>
          <SideMenu />
        </Col>
        <Col x={16}>
          <Content maxWidth={'100%'} padding={'0 0 0 95px'}>
            <div style={{ display: 'flex', flexDirection: 'column' }}>
              <Title
                style={{
                  fontSize: 32,
                  fontWeight: 700,
                  color: 'var(--black-color)',
                }}
              >
                주문상세
              </Title>
            </div>

            <div
              style={{
                //borderTop: '2px solid var(--black-color)',
                borderBottom: '2px solid var(--black-color)',
                marginTop: 23,
              }}
            >
              <OrderListTable
                orders={recentOrderList}
                detailText={'배송조회'}
                showExpectedCycle={true}
              />
            </div>

            <div
              style={{
                display: 'flex',
                justifyContent: 'end',
                alignItems: 'center',
                marginTop: 24,
                gap: 17,
              }}
            >
              <Button style={{ ...styles.button }}>배송미루기</Button>
              <Button style={{ ...styles.button }}>수량변경</Button>
              <Button style={{ ...styles.button }}>구독취소</Button>
            </div>

            <div
              style={{
                margin: '140px 0',
              }}
            >
              <div
                style={{
                  ...styles.titleLayout,
                }}
              >
                <Title style={{ ...styles.title }}>배송 정보</Title>
                <img src={more} alt="more icon" style={{ cursor: 'pointer' }} />
              </div>

              {/* 내용 */}
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  padding: '32px 40px',
                }}
              >
                <Text style={{ fontWeight: 700 }}>제이엠</Text>
                <Text style={{ margin: '4px 0' }}>010-1234-5678</Text>
                <Text>
                  (46079) 부산광역시 기장군 기장읍 대변3길 8 제이엠커피로스터스
                </Text>
              </div>
              <Text
                style={{ padding: '16px 40px', backgroundColor: '#f4f4f4' }}
              >
                부재시 경비실에 맡겨주세요.
              </Text>
            </div>

            {/* 결제정보 */}
            <div
              style={{
                margin: '140px 0',
              }}
            >
              <div
                style={{
                  ...styles.titleLayout,
                }}
              >
                <Title style={{ ...styles.title }}>결제 정보</Title>
                <img src={more} alt="more icon" style={{ cursor: 'pointer' }} />
              </div>

              <div
                style={{
                  display: 'flex',
                  borderBottom: '1px solid #ddd',
                }}
              >
                {/* 주문금액 */}
                <div
                  style={{
                    ...styles.container,
                    width: '30.71%',
                    borderRight: '1px solid #ddd',
                  }}
                >
                  <div
                    style={{
                      ...styles.section,
                      borderBottom: '1px solid #ddd',
                      position: 'relative',
                    }}
                  >
                    <img
                      src={remove}
                      alt="remove icon"
                      style={{
                        width: 24,
                        position: 'absolute',
                        top: '50%',
                        right: '-12px',
                        transform: 'translateY(-50%)',
                      }}
                    />
                    <span style={styles.paytitle}>주문금액</span>
                    <Text style={styles.paytitle}>
                      {stringToMoneyFormat(152100)}
                      <span>원</span>
                    </Text>
                  </div>
                  <div style={styles.columnSection}>
                    <div style={styles.row}>
                      <span style={styles.text}>상품금액</span>
                      <Text style={styles.text}>
                        {stringToMoneyFormat(152100)}
                        <span>원</span>
                      </Text>
                    </div>
                    <div style={styles.row}>
                      <span style={styles.text}>배송비</span>
                      <Text style={styles.text}>
                        {stringToMoneyFormat(0)}
                        <span>원</span>
                      </Text>
                    </div>
                  </div>
                </div>
                {/* 주문금액 끝 */}
                {/* 할인금액 */}
                <div
                  style={{
                    ...styles.container,
                    width: '30.71%',
                    borderRight: '1px solid #ddd',
                  }}
                >
                  <div style={{ ...styles.section, position: 'relative' }}>
                    <img
                      src={equal}
                      alt="equal icon"
                      style={{
                        width: 24,
                        position: 'absolute',
                        top: '50%',
                        right: '-12px',
                        transform: 'translateY(-50%)',
                      }}
                    />
                    <span style={styles.paytitle}>할인금액</span>
                    <Text style={styles.paytitle}>
                      {stringToMoneyFormat(152100)}
                      <span>원</span>
                    </Text>
                  </div>
                  <div style={styles.columnSection}>
                    <div style={styles.row}>
                      <span style={styles.text}>포인트</span>
                      <Text style={styles.text}>
                        {stringToMoneyFormat(152100)}
                        <span>원</span>
                      </Text>
                    </div>
                    <div style={styles.row}>
                      <span style={styles.text}>쿠폰</span>
                      <Text style={styles.text}>
                        {stringToMoneyFormat(0)}
                        <span>원</span>
                      </Text>
                    </div>
                    <div
                      style={{
                        display: 'flex',
                        flexDirection: 'column',
                        gap: 4,
                      }}
                    >
                      <div style={styles.row}>
                        <Text style={styles.lighttext}>
                          - 29% 특별 할인쿠폰
                        </Text>
                        <Text style={styles.lighttext}>
                          {stringToMoneyFormat(44109)}
                          <span>원</span>
                        </Text>
                      </div>
                      <div style={styles.row}>
                        <Text style={styles.lighttext}>- 중복 할인쿠폰</Text>
                        <Text style={styles.lighttext}>
                          {stringToMoneyFormat(44109)}
                          <span>원</span>
                        </Text>
                      </div>
                    </div>
                  </div>
                </div>
                {/* 할인금액 끝 */}
                {/* 결제금액 */}
                <div style={{ ...styles.container, width: '38.48%' }}>
                  <div style={styles.section}>
                    <span style={styles.paytitle}>결제금액</span>
                    <Text
                      style={{
                        ...styles.paytitle,
                        color: 'var(--red-secondary-color)',
                        fontSize: 18,
                      }}
                    >
                      {stringToMoneyFormat(107130)}
                      <span>원</span>
                    </Text>
                  </div>
                  <div style={styles.columnSection}>
                    <div style={styles.row}>
                      <span style={styles.text}>카카오페이</span>
                      <Text style={styles.text}>
                        {stringToMoneyFormat(107130)}
                        <span>원</span>
                      </Text>
                    </div>
                    <div
                      style={{
                        display: 'flex',
                        flexDirection: 'column',
                        gap: 4,
                      }}
                    >
                      <div style={styles.row}>
                        <span style={styles.lighttext}>결제일시</span>
                        <Text style={styles.lighttext}>2024.12.31 22:19</Text>
                      </div>
                      <div style={styles.row}>
                        <span style={styles.lighttext}>적립혜택</span>
                        <Text style={styles.lighttext}>
                          <span>+</span>
                          {stringToMoneyFormat(1071)}
                        </Text>
                      </div>
                    </div>
                  </div>
                </div>
                {/* 결제금액 끝 */}
              </div>
            </div>
            {/* 결제정보 끝 */}
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <Button style={styles.listButton}>목록</Button>
            </div>
          </Content>
        </Col>
        <Col x={2}></Col>
      </Row>
    </Content>
  );
};

export default MypageSubscribeDetailsPresenter;
